import { Slot } from 'radix-ui'
import { cva, type VariantProps } from 'class-variance-authority'
import type { ComponentProps } from 'react'
import { cn } from '../cn'

const button = cva(
  'inline-flex items-center justify-center gap-2 rounded-[var(--radius-control)] text-sm font-medium transition-colors outline-none focus-visible:ring-3 focus-visible:ring-[var(--ad-ring)] disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        primary:
          'bg-[var(--ad-primary)] text-[var(--ad-primary-fg)] hover:bg-[var(--ad-primary-hover)]',
        secondary:
          'border border-[var(--ad-border)] bg-[var(--ad-surface)] text-[var(--ad-text)] hover:bg-[var(--ad-surface-muted)]',
        ghost: 'text-[var(--ad-text)] hover:bg-[var(--ad-surface-muted)]',
        danger: 'bg-[var(--ad-danger)] text-[var(--ad-danger-fg)] hover:opacity-90',
      },
      size: {
        sm: 'h-8 px-3',
        md: 'h-10 px-4',
        lg: 'h-11 px-6',
        icon: 'size-10',
      },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
  },
)

export type ButtonProps = ComponentProps<'button'> &
  VariantProps<typeof button> & {
    /** Çocuğu düğme gibi davranan bir elemana dönüştürür (ör. router bağlantısı). */
    asChild?: boolean
  }

export function Button({ className, variant, size, asChild, ...props }: ButtonProps) {
  const Component = asChild ? Slot.Root : 'button'
  return <Component className={cn(button({ variant, size }), className)} {...props} />
}
